package pl.mothdigital.neuronowi.components.widgets

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.core.PageContext
import pl.mothdigital.neuronowi.navigation.Screen

@Composable
fun MenuItems(context: PageContext) {
    NavItem(
        text = "Strona główna",
        route = Screen.Home.route,
        isRoute = Screen.takeRoute(context.route.path) == Screen.Home
    )
    NavItem(
        text = "O nas",
        route = Screen.About.route,
        isRoute = Screen.takeRoute(context.route.path) == Screen.About
    )
    NavItem(
        text = "Specjaliści",
        route = Screen.Specialists.route,
        isRoute = Screen.takeRoute(context.route.path) == Screen.Specialists
    )
    NavItem(
        text = "Terapie",
        route = Screen.Therapies.route,
        isRoute = Screen.takeRoute(context.route.path) == Screen.Therapies
    )
    NavItem(
        text = "Kontakt",
        route = Screen.Contact.route,
        isRoute = Screen.takeRoute(context.route.path) == Screen.Contact
    )
}
